export default {
    namespaced: true,
    state: {
        appMetro: false
    },
    mutations: {
        esAppMetro(state, appMetro) {
            state.appMetro = appMetro;
        }
    },
    actions: {
        appMetroTrue({
            commit
        }, payload) {
            commit("esAppMetro", true);
        },
        appMetroFalse({
            commit
        }, payload) {
            commit("esAppMetro", false);
        }
    }
}
